import SelfService from './SelfService';

export default SelfService;